export function checkMatch(haystack: string, needle: RegExp): boolean {
  return haystack.match(needle) !== null ? true : false;
}
